// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3XbZr","head":"ProcedureTableInfo_head__2ka3x"};